module.exports = __webpack_public_path__ + "static/stray-b257ae8d2da7b42b46ad84bc6f6492ee.m4a";